import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';

export function HelloPage() {
  const { status, user, roles } = useAuth();
  if (status === 'loading') {
    return <p className="text-slate-600">Loading…</p>;
  }
  // Signed-in users with a role land straight on the board. Role-less users
  // stay here (redirecting them would loop with the /portfolio guard).
  if (status === 'signed-in' && user && roles.length > 0) {
    return <Navigate to="/portfolio" replace />;
  }
  if (status === 'anonymous' || !user) {
    return (
      <div>
        <h1 className="text-2xl font-semibold">
          Welcome to <span className="font-display font-extrabold"><span className="text-brand">más</span>Flow</span>
        </h1>
        <p className="mt-2 text-slate-600">Please sign in to continue.</p>
        <a
          className="mt-4 inline-block rounded-full bg-brand px-5 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-dark"
          href="/.auth/login/aad?post_login_redirect_uri=/"
        >
          Sign in with Microsoft
        </a>
      </div>
    );
  }
  if (status === 'error') {
    return <p className="text-red-700">Could not load your session. Reload the page.</p>;
  }
  return (
    <div>
      <h1 className="text-2xl font-semibold">Hello, {user.userDetails}</h1>
      <p className="mt-2 text-slate-600">
        You are signed in via {user.identityProvider}.
      </p>
      <div className="mt-4">
        <p className="text-sm font-medium text-slate-700">Your roles:</p>
        <ul className="mt-1 flex flex-wrap gap-2">
          {roles.length === 0 ? (
            <li className="text-sm italic text-slate-500">No Flow role assigned.</li>
          ) : (
            roles.map((r) => (
              <li key={r} className="rounded bg-slate-200 px-2 py-0.5 text-xs">
                {r}
              </li>
            ))
          )}
        </ul>
      </div>
      {roles.includes('admin') && (
        <a
          className="mt-6 inline-block rounded bg-slate-800 px-3 py-1.5 text-sm text-white"
          href="/portfolio"
        >
          Go to Portfolio →
        </a>
      )}
    </div>
  );
}
